import $ from "jquery"


class ProjectsFilter {

    menu = $('#projects').find( 'ul.nav')
    projects = $("#projects").find('#loop')
    selectors = []

    constructor() {

        console.log( 'epp' )
        this.menu.find('button.active').each( (item , element ) => {
            this.selectors.push( $(element).attr('data-target') )
        });

        this.click( this.menu.find('.active') )

        this.menu.on( 'click' , 'button' , (e) => {  
            console.log(  e.currentTarget  )         
            this.click( e.currentTarget )
        })
    }


    click( elt ){
        this.menu.find( 'button' ).removeClass( 'active' )
        $(elt).addClass( 'active' )
        this.update()
    }


    update(){
        this.selectors = []
        this.menu.find('button.active').each( (item , element ) => {
            this.selectors.push( $(element).attr('data-target') )
        });

        this.projects.find( '.project' ).addClass('d-none')

        this.selectors.forEach( elt => {
            $('.project[data-tax="' + elt + '"]').removeClass('d-none')
        })
    }
    
}

export {ProjectsFilter};